const INVALID_NUMBER_ERROR = 'Please enter a valid phone #';

export { INVALID_NUMBER_ERROR };
